(function() {
  // Define the Splide configuration object inside the closure to prevent global redeclaration errors
  const splideConfig = {
    perPage: 3,
    focus  : 0,
    omitEnd: true,
    perMove: 1,
    padding: { right: '0%' },
    pagination: false,
    arrows: false,
    drag: false,
    breakpoints : {
      989: {
        perPage: 2,
        perMove: 1,
        gap: '0px',
        pagination: true,
        padding: { right: '20%' },
      },
      767: {
        perPage: 1,
        perMove: 1,
        gap: '0px',
        pagination: true,
        padding: { right: '20%' },
      },
      430: {
        perPage: 1,
        perMove: 1,
        gap: '0px',
        pagination: true,
        padding: { right: '10%' },
      },
    },     
  };
  
  function getCurrentPadding() {
    const width = window.innerWidth;
    if (width <= 430) {
      return { right: '10%' };
    } else if (width <= 767) {
      return { right: '20%' };
    } else if (width <= 989) {
      return { right: '20%' };
    } else {
      return { right: '0%' };
    }
  }
  
  function initSplides() {
    // Find all sections by a class name, ignoring ones we've already initialized
    const sliders = document.querySelectorAll('.multicolumn-about-splide:not(.is-initialized)');
  
    sliders.forEach((sliderElement) => {
      const splide = new Splide(sliderElement, splideConfig);
    
      splide.on('overflow', function(isOverflow) {
        const options = {
          pagination: isOverflow,
          drag: isOverflow,
        };
        splide.options = { ...splide.options, ...options };
        if (splide.initialized) {
          splide.refresh();
        }
      });
    
      window.addEventListener('resize', () => {
        const newPadding = getCurrentPadding();
        splide.options = { ...splide.options, padding: newPadding };
        if (splide.initialized) {
          splide.refresh();
        }
      });
    
      splide.mount();
      
      // Mark this specific slider as initialized so Shopify Theme Editor doesn't double-mount it
      sliderElement.classList.add('is-initialized'); 
    });
  }
  
  document.addEventListener('DOMContentLoaded', initSplides);
  document.addEventListener('shopify:section:load', initSplides);

})();